module.exports = __webpack_public_path__ + "static/media/wrinkles_crowsfeet.bc4e70fc.svg";